import { render } from "./ApplicationViewB.vue?vue&type=template&id=642daff2&scoped=true"
import script from "./ApplicationViewB.vue?vue&type=script&lang=js"
export * from "./ApplicationViewB.vue?vue&type=script&lang=js"

import "./ApplicationViewB.vue?vue&type=style&index=0&id=642daff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642daff2"]])

export default __exports__